import React, { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";

/**
 * Legacy redirect: /comune/:slug -> /ricerca-perdite-acqua-:slug
 * Performs a 301-style redirect (client-side replace) AND injects a noindex
 * meta + canonical so search engines understand the new canonical URL even
 * before the redirect resolves. The new SEO-friendly URL contains the primary
 * keyword "ricerca-perdite-acqua-{slug}" and is now the canonical one for
 * every comune page.
 */
export default function ComuneRedirect() {
  const { slug } = useParams();
  useEffect(() => {
    // Browser-level hint: ensure no caching of the old URL as canonical.
    // Search bots that follow the JS redirect get the new URL; the canonical
    // we emit in <SEO /> also points to the new location.
    if (typeof document !== "undefined") {
      document.title = "Reindirizzamento...";
    }
  }, []);
  if (!slug) return <Navigate to="/" replace />;
  return <Navigate to={`/ricerca-perdite-acqua-${slug}`} replace />;
}
